import { LocalChannel } from "@core/enums";
import { Tip, TipDetail, WorkDay } from "@core/models";
import { IntegerPrecisionService } from "@core/services";
import { tipCalculationProcessor } from '@core/domain/tip';

export function transformToData(tipList: Tip[]): Tip {

  const tipChannel = (tipList?.find((tip)=>tip.nombreModulo == LocalChannel.JuvoOlo) ?? {}) as Tip

  return {
    ...tipChannel,
    detallesPropinas: tipChannel.detallesPropinas.filter((tipDetail)=>tipDetail.valor != 0)
  }
}

export function convertTipPercentToDecimal(tip: TipDetail | null): TipDetail | null {
  if (!tip) return null;
  return {
    ...tip,
    percent: tip.percent ? tip.percent / 100 : 0,
  };
}

export function calculateTipList(
  tipDetails: TipDetail[] | null | undefined,
  subtotalBigInt: bigint,
  workDay: WorkDay | null
): TipDetail[] {
  if (!tipDetails?.length || !workDay) return [];
  const math = new IntegerPrecisionService();

  return tipCalculationProcessor.calculateOptions(tipDetails, subtotalBigInt, math, workDay);
}